import { LogOut } from "lucide-react";
import type { Me, Trip } from "../lib/api.ts";
import { signOut } from "../lib/session.ts";
import { Card, ICON } from "../ui/index.ts";
import { YouCard } from "./YouCard.tsx";

/**
 * Who you are on this trip: the name everyone sees, the colour your marks are drawn in, and the
 * way out.
 *
 * All three used to be on Settings, and two of them were not together: your name and colour sat
 * near the top, Sign out sat at the foot of the page under a second heading also called "You".
 * Signing out is the last thing you do with an account, so it is the last thing on the page that
 * is about your account -- not a card of its own in another part of the list.
 */
export function ProfilePage({ trip, me }: { trip: Trip; me: Me }) {
  return (
    <div className="stack">
      <YouCard trip={trip} me={me} />
      <Card>
        <div className="row wrap">
          <span className="muted small">Signed in as {me.user.displayName}</span>
          <span className="spacer" />
          <button
            type="button"
            className="button small"
            onClick={async () => {
              await signOut();
              window.location.assign("/");
            }}
          >
            <LogOut {...ICON} aria-hidden="true" />
            Sign out
          </button>
        </div>
      </Card>
    </div>
  );
}
